import { apiPaths } from './config/apiPaths';
import { postJson } from './postClient';

function buildContactsRequestBody(inputData = {}) {
  return {
    operation: inputData.operation,
    payload: inputData.payload ?? {},
  };
}

export function contactsChannelRequest(inputData, authHeaders, defaultError) {
  return postJson(
    apiPaths.entitlements,
    buildContactsRequestBody(inputData),
    authHeaders,
    { defaultError }
  );
}

export const listContactsApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to load contacts');

export const addContactApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to add contact');

export const updateContactApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to update contact');

export const deleteContactApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to delete contact');

export const listSegmentsApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to load segments');

export const createSegmentApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to create segment');

export const deleteSegmentApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to delete segment');

export const getContactStatsApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to load contact stats');

export const importContactsApi = (inputData, authHeaders) =>
  contactsChannelRequest(inputData, authHeaders, 'Failed to import contacts');
